import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

const LocationWrapper = styled.div`
  white-space: pre-line;
  padding: 29px 0;
  .location_meta {
    margin-bottom: 29px;
  }
  a {
    color: ${themeGet('primary.0', '#194AB9')};
    &:hover {
      opacity: 0.8;
    }
  }
`;

export default LocationWrapper;
